/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_ApproveInputs */

const da_forside_preview_approve = /** @type {(inputs: Forside_Preview_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godkend karakter`)
};

/** @type {(inputs: Forside_Preview_ApproveInputs) => LocalizedString} */
const en_forside_preview_approve = da_forside_preview_approve;

/**

* @param {Forside_Preview_ApproveInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_approve = /** @type {((inputs?: Forside_Preview_ApproveInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_ApproveInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_approve(inputs)
	return /** @type {LocalizedString} */ ("Godkend karakter")
});